import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useCurrentBot } from "../../../../Store/Slices/DashboardSlices";
import { getActiveNode, getLanguage, setFlowBuilderPopup, updateModifiedData } from "../../Slices/main.slice";
import { getInitialEditorText, getMediaDetails,cleanMediaDetails, getResponse, getText } from "../../Utils";
import { useAppDispatch } from "../../../../Store";
import { getChannelWiseText, getHTMLContent, getLocationDetails, getPlainTextData } from "../../Utils/editor";
import MessagePreview from "../../Components/MessagePreview";
import AppButton from "../../../../AppComponents/AppButton";
import MyLocationIcon from '@mui/icons-material/MyLocation';
import TelegramIcon from '@mui/icons-material/Telegram';
import "mapbox-gl/dist/mapbox-gl.css";
import MapLocationPopup from "./mapPopup";
import Editor from "../../Components/Editor"
import { useNotification } from "../../../../Hooks/useNotification/useNotification";
import { isEmptyObject } from "../../../../Utils";

const MAPBOX_TOKEN = process.env.REACT_APP_LOCATION;

const ShareLocationNode = (props: NodeProps) => {
  const [showMapPopup, setShowMapPopup] = useState<any>(false);
  const { node } = props;
    const {showAlert} = useNotification();
  const language = useSelector(getLanguage);
  const activeNode = useSelector(getActiveNode);
  const response = getResponse(node, language);
  const text = getText(response);
  const media = getLocationDetails(response);
  const [editorState, setEditorState] = useState(getInitialEditorText(text || ""));
  const isActiveNode = activeNode === node.nodeId;
  const dispatch = useAppDispatch();

  const [location, setLocation] = useState<any>(media);

  const handleUseCurrentLocation = () => {
    if (!navigator.geolocation) {
      showAlert("Geolocation not supported", "error");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        const { latitude, longitude } = pos.coords;
        handleLocationSelect({ latitude, longitude });
      },
      (err) => {
        showAlert("Unable to fetch location", "error");
        console.error(err);
      }
    );
  };

  const handleLocationSelect = async ({ latitude, longitude }: any) => {
    try {
      const res = await fetch(
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${longitude},${latitude}.json?access_token=${MAPBOX_TOKEN}`
      );
      const data = await res.json();
      const place = data.features?.[0];
      const payload = {
        name: place?.text || "Selected Location",
        address: place?.place_name || "Unknown address",
        latitude,
        longitude,
        url: `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`,
      };
      setLocation({
        type: "share-location",
        value: payload
      });
      setShowMapPopup(false);
      dispatch(setFlowBuilderPopup(false));
    } catch (e) {
      console.error("Error fetching address", e);
    }
  };

  const onEditorStateChange = (editorState: any, mediaInfo: any) => {
      setEditorState(editorState);
        if(cleanMediaDetails(mediaInfo)){
        dispatch(
          updateModifiedData([
            {
              type: "share-location",
              value:mediaInfo?.value
            },
          ]),
        );
      }
    };

    const onClickShareLocation = () => {
      setShowMapPopup(true);
      dispatch(setFlowBuilderPopup(true));
    }

    const onClickCancelPopup = () => {
      dispatch(setFlowBuilderPopup(false));
      setShowMapPopup(false);
    }

  return (
    <>
    <div style={{ padding: isActiveNode ? "8px 16px" : "0px", height: isActiveNode ? "auto": location?.value?.latitude ? "465px": "100px"}}>
      {isActiveNode ? (
        <div>
          {
              (!(isEmptyObject(location))) &&
              <Editor
              editorState={editorState}
              onEditorStateChange={onEditorStateChange}
              error={getPlainTextData(editorState) === ""}
              mediaInfo={location}
              readOnly={true}
              disableAllOptions = {true}
            />
            }

          <div style={{ display: "flex", flexDirection: "column", gap: "10px", padding: "3px 5px" }}>
            <AppButton onClick={onClickShareLocation}>
              <TelegramIcon /> Share your location
            </AppButton>
            <AppButton onClick={handleUseCurrentLocation}>
              <MyLocationIcon /> Use Current Location
            </AppButton>
          </div>
          <div>
            {showMapPopup && (
            <MapLocationPopup
              onSave={handleLocationSelect}
              initialData = {location}
              onCancel={onClickCancelPopup}
            />
          )}
          </div>
        </div>
      ) : (
        <MessagePreview mediaDetails={media} nodeType = {"share-location"} />
      )}
    </div>
    </>
  );
};

export default ShareLocationNode;
